export default __webpack_public_path__ + "static/media/My City 2018 -- Charcoal and Pastel on Paper -- 48in x 24in.18c5dcc4.jpg";